import type { DecodeInput, DecodedTransaction } from '@sol-tx-visualizer/tx-decode';
import { decodeTransaction } from '@sol-tx-visualizer/tx-decode';

const API_BASE = import.meta.env.VITE_API_URL || '';

export interface RawTransactionResponse {
  signature: string;
  slot: number;
  blockTime: number | null;
  meta: unknown;
  transaction: unknown;
}

export async function fetchTransaction(signature: string): Promise<DecodedTransaction> {
  const res = await fetch(`${API_BASE}/api/tx/${encodeURIComponent(signature)}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  const raw: RawTransactionResponse = await res.json();

  const input: DecodeInput = {
    signature: raw.signature,
    slot: raw.slot,
    blockTime: raw.blockTime,
    meta: raw.meta as DecodeInput['meta'],
    transaction: raw.transaction as DecodeInput['transaction'],
  };

  return decodeTransaction(input);
}
